<template lang='pug'>
  .edit-image
    .form_group
      .form-item
        label
          | Destination
        el-select(
          v-model='button_destination'
          @change='change_destination($event)')
          el-option(
            v-for="option in button_destination_options"
            :key="option.value"
            :label="option.label"
            :value="option.value")
      .form-item(v-if='button_destination === "website"')
        label
          | Fallback URL*
        el-input.button_text_input(
          v-model='fallback_url'
          name='fallback_url'
          data-vv-as='fallback url'
          v-validate="'required|url'"
          @input='change($event, "fallback_url")'
        )
        .errors
          span {{ errors.first('fallback_url') }}
      .form-item(v-if='button_destination === "custom"')
        label
          | Custom URL*
        el-input.button_text_input(
          v-model='fallback_url'
          name='fallback_url'
          data-vv-as='custom url'
          v-validate="'required|url'"
          @input='change($event, "fallback_url")'
        )
        .errors
          span {{ errors.first('fallback_url') }}
      .form-item(v-if='button_destination === "custom_field"')
        label
          | Custom Field
        el-select(
          :value='custom_field_label'
          @change='change_custom_field_id($event)')
          el-option(
            v-for="option in custom_field_options"
            :key="option.value"
            :label="option.label"
            :value="option.value")
        .warning
          | The retailer’s phone number will be used if either the custom field value is empty or if it contains invalid characters.
      .form-item(v-if='button_destination === "download"')
        .upload-thumbnail
          .upload-thumbnail-image(v-if='has_uploaded_file')
            img(:src='thumbnail')
          .upload-thumbnail-placeholder(v-else)
            i.pbxx-icon.pbxx-icon-crop-original
        .upload-options
          .upload-copy(v-if='has_uploaded_file')
            | {{ download_filename }}
          .upload-copy(v-else)
            | Upload your downloadable file
          digital_asset_uploader(
            :associable_endpoint='get_associable_endpoint'
            :authorization='get_authorization'
            :multiple='false'
            :show_input='false'
            :replace='true'
            :digital_asset_params='{}'
            :empty_uploader='false'
            :action_endpoint='cloudinary_endpoint'
            :class='{ "has_uploaded_file": has_uploaded_file }'
            @upload_success='on_upload_success')
      .form-item
        label
          | Button Text
        el-input.button_text_input(
          :value='button_text'
          placeholder='Customize button text (optional)'
          @input='change($event, "button_text")'
        )
      .form-item
        label
          | Button Font
        el-select(
          v-model='button_font'
          @change='change($event, "button_font")')
          el-option(
            v-for="option in font_options"
            :key="option.value"
            :value="option.value")
              span(:style="{fontFamily: option.value}") {{option.value}}
      .form-item
        label
          | Button Color
        pbxx_color_picker(
          :color='button_color'
          @input='change($event, "button_color")')
      .form-item
        label
          | Text Color
        pbxx_color_picker(
          :color='text_color'
          @input='change($event, "text_color")')
</template>

<script>
  import Cookies from 'js-cookie'
  import { config_obj } from '../utils/firebase'
  import cloudinary_initializer from '../mixins/cloudinary_initializer'

  export default {
    name: 'cta',
    mixins: [
      cloudinary_initializer
    ],
    props: {
      landing_page_widget: {
        type: Object,
        required: true
      },
      asset_public_id: {
        type: String,
        required: false,
        default: ""
      },
      campaign: {
        type: Object
      },
      campaign_id: {
        type: String,
        required: true
      },
      custom_fields: {
        type: Array,
      },
      brand: {
        type: Object,
        required: true
      }
    },
    inject: {
      $validator: '$validator'
    },
    data() {
      return {
        default_fonts: [
          { value: 'Lato', label: 'Lato' },
          { value: 'Lucida Sans Unicode', label: 'Lucida Sans' },
          { value: 'Open Sans', label: 'Open Sans' },
          { value: 'Trebuchet', label: 'Trebuchet' },
          { value: 'Source Sans Pro', label: 'Source Sans Pro' },
          { value: 'Roboto', label: 'Roboto' }
        ],
        cloudinary_params: {},
        custom_field_label: ''
      }
    },
    computed: {
      button_destination_options() {
        const { custom_fields } = this
        const options = [
          { value: 'website', label: 'Retailer Website' },
          { value: 'phone', label: 'Retailer Phone' },
          { value: 'directions', label: 'Directions' },
          { value: 'download', label: 'File Download' },
          { value: 'custom', label: 'Custom Link' }
        ]
        if(custom_fields.length) options.splice(2, 0, {value: 'custom_field', label: 'Custom Phone'})
        return options
      },
      custom_field_options() {
        const { custom_fields } = this
        const options = custom_fields.map(field => {
          return {value: field.id, label: field.display_name}
        })
        return options
      },
      custom_field_type() {
        return this.landing_page_widget.draft_content.custom_field_type
      },
      font_options() {
        const google_fonts = this.brand.fonts ?
          this.brand.fonts.map(font => {
            return {
              value: font.family,
              label: font.family
            }
          })
          :
          []

        const custom_fonts = this.brand.custom_fonts ?
          this.brand.custom_fonts.map(font => {
            return {
              value: font.family,
              label: font.family
            }
          })
          :
          []
        return [...this.default_fonts, ...google_fonts,...custom_fonts]
      },
      fallback_url() {
        return this.landing_page_widget.draft_content.fallback_url
      },
      button_color() {
        return this.landing_page_widget.draft_content.button_color
      },
      text_color() {
        return this.landing_page_widget.draft_content.text_color
      },
      button_text() {
        return this.landing_page_widget.draft_content.button_text
      },
      button_font() {
        return this.landing_page_widget.draft_content.button_font
      },
      button_destination() {
        return this.landing_page_widget.draft_content.button_destination
      },
      has_uploaded_file() {
        return this.landing_page_widget.draft_content.download_public_id.length > 0
      },
      download_preview_url() {
        return this.landing_page_widget.draft_content.download_preview_url
      },
      download_filename() {
        return this.landing_page_widget.draft_content.download_filename
      },
      thumbnail() {
        return this.cl.url(this.landing_page_widget.draft_content.download_public_id, {
            width: '52',
            height: '52',
            dpr: 'auto',
            fetch_format: 'auto',
            quality: 'auto',
            crop: 'thumb',
            client_hints: true
          })
      },
      get_authorization() {
        return Cookies.get('token')
      },
      get_associable_endpoint() {
        return `${config_obj.api_base_path}/v2/campaigns/${this.campaign_id}`
      },
      cloud_name() {
        return config_obj.cloudinary_cloud_name
      },
      cloudinary_endpoint() {
        return `https://api.cloudinary.com/v1_1/${this.cloud_name}/upload`
      }
    },
    methods: {
      change(val, key) {
        this.landing_page_widget.draft_content[key] = val
        this.$emit('input', this.landing_page_widget)
      },
      change_custom_field_id(val){
        this.landing_page_widget.draft_content.custom_field_id = val
        this.$emit('input', this.landing_page_widget)
        this.get_custom_field_label()
      },
      change_custom_field_type(type){
        this.landing_page_widget.draft_content.custom_field_type = type
        this.$emit('input', this.landing_page_widget)
      },
      get_custom_field_label(){
        const {draft_content} = this.landing_page_widget
        const {custom_field_id} = draft_content

        if (!custom_field_id) {
          this.custom_field_label = ""
        }
        else {
          const field = this.custom_fields.find(field => custom_field_id === field.id)
          this.custom_field_label = field ? field.display_name : ""
        }
      },
      change_destination(val) {
        switch (val) {
          case 'custom':
            this.landing_page_widget.draft_content.button_text = 'Click Here'
            this.landing_page_widget.draft_content.download_public_id = ''
            this.landing_page_widget.draft_content.fallback_url = ''
            break
          case 'phone':
            this.landing_page_widget.draft_content.button_text = 'Call {{ retailer.name }}'
            this.landing_page_widget.draft_content.download_public_id = ''
            break
          case 'custom_field':
            this.landing_page_widget.draft_content.button_text = 'Call {{ retailer.name }}'
            this.landing_page_widget.draft_content.download_public_id = ''
            break
          case 'directions':
            this.landing_page_widget.draft_content.button_text = 'Get Directions'
            this.landing_page_widget.draft_content.download_public_id = ''
            break
          case 'download':
            this.landing_page_widget.draft_content.button_text = 'Download Now'
            this.landing_page_widget.draft_content.download_public_id = ''
            break
          case 'website':
          default:
            this.landing_page_widget.draft_content.button_text = 'Shop Now at {{ retailer.name }}'
            this.landing_page_widget.draft_content.download_public_id = ''
            this.landing_page_widget.draft_content.fallback_url = this.brand.website
        }
        this.landing_page_widget.draft_content.button_destination = val
        this.$emit('input', this.landing_page_widget)
      },
      on_upload_success(event) {
        this.$notify.success({
          title: 'Success',
          message: 'Your asset is ready for download'
        })
        let url = event.secure_url
        this.landing_page_widget.draft_content.download_preview_url = url
        this.landing_page_widget.draft_content.download_public_id = event.public_id
        this.landing_page_widget.draft_content.download_filename = `${event.original_filename}.${event.format}`
        url = url.replace(/upload\/v/i, 'upload/fl_attachment/v')
        this.landing_page_widget.draft_content.download_url = url
        this.$emit('input', this.landing_page_widget)
      }
    },
    mounted() {
      this.get_custom_field_label()
      if (this.landing_page_widget.draft_content.button_destination === 'website' && this.landing_page_widget.draft_content.fallback_url === "") {
        this.landing_page_widget.draft_content.fallback_url = this.brand.website || ''
        this.$emit('input', this.landing_page_widget)
      }
    }
  }
</script>

<style lang='scss'>
  // Making upload look
  // Like a button instead of
  // Drag and drop upload
  .upload-options {
    .digital-asset-uploader {
      display: inline-block;
      vertical-align: top;
      .upload-video {
        display: none;
      }
      > div > .el-upload.el-upload--text {
        border: 1px solid #BDBDBD;
        padding: 0.5em 1em;
        border-radius: .25em;
        font-size: 12px;
        width: auto;
        &:hover,
        &:focus {
          background: #F4F4F4;
        }
        &:after {
          content: 'Upload';
          color: #323232;
          display: block;
        }
        > .el-upload-dragger {
          display: none;
        }
      }
      &.has_uploaded_file > div > .el-upload.el-upload--text:after {
        content: 'Replace';
      }
    }
  }
</style>

<style lang='scss' scoped>
  @import "@promoboxx/pbxx2component/src/styles/variables_and_mixins";

  .form-item {
    margin-bottom: 20px;
    .errors {
      color: red;
    }
    .warning {
      color: orange;
    }
  }

  .upload {
    &-thumbnail,
    &-options {
      display: inline-block;
      vertical-align: top;
    }
    &-thumbnail {
      height: 52px;
      width: 52px;
      margin-right: 15px;
      &-placeholder {
        text-align: center;
        color: get-color(gray);
        background: get-color(gray-lightest);
        height: 100%;
        font-size: 36px;
      }
    }
    &-copy {
      font-size: 12px;
      margin-bottom: 4px;
      width: 300px;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }
  }

</style>
